/*
import {
  hf,
  ht,
  cr,
  gs,
  ls,
} from 'lib';
*/
import * as cr from './_cr';
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import * as ht from './_ht';

import * as icm from './icm';

import * as icvBaseS10Rz from './icvBaseS10Rz';

import * as icvI10S10To from './icvI10S10To';
import * as icvI10S10Co from './icvI10S10Co';

export const N = (pDz: {
  sPz: ht.dz,
}) => {

  const _gUserz = gs.useUserz();

  const _sPz = ls.usePz({
    steps: [0],
    phs: 'dpy',
    lblz: icm.grtLblz({
      tgt: '部屋',
    })
  });

  icm.loadAtTopAsync({
    _31r_fst: _gUserz.crt._31rz?._fst,
    frcUdt: _sPz.udt,
  });

  return (
    cr.c(icvBaseS10Rz.N, {
      key: -101,
      cz: {
        pageName: 
          _sPz.crt.steps[0] == 0 ?
            _sPz.crt.lblz.ttlz.top
          : _sPz.crt.steps[0] == 1 ?
            _sPz.crt.lblz.ttlz.ctt
          : ''
      },
      oClds: [

        _sPz.crt.steps[0] == 0 ?
        cr.c(icvI10S10To.N, {
          key: -102,
          sPz: _sPz,
        })
        : null,

        _sPz.crt.steps[0] == 1 ?
        cr.c(icvI10S10Co.N, {
          key: -203,
          sPz: _sPz,
        })
        : null,

      ]
    })
  );
};
